// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.admin-navigation {
  position: sticky;
  top: 0;
  z-index: 100;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  padding: 13px 26px;
  border-bottom: 1px solid #334155;
  display: flex;
  align-items: center;
  gap: 22px;
}

.admin-brand {
  color: #10b981;
  font-size: 20px;
  font-weight: 800;
  white-space: nowrap;
}

.admin-nav-scroll {
  display: flex;
  align-items: center;
  gap: 5px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.admin-nav-link {
  padding: 9px 13px;
  color: #cbd5e1;
  text-decoration: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  transition: all .2s;
}

.admin-nav-link:hover { background: #26384f; color: #f8fafc; }
.admin-nav-link-active { background: #10b981; color: #0f172a; }

@media (max-width: 760px) {
  .admin-navigation { padding: 11px 14px; align-items: flex-start; flex-direction: column; gap: 8px; }
  .admin-nav-scroll { width: 100%; padding-bottom: 3px; }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,oBAAoB,kBAAkB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE;EACnG,oBAAoB,WAAW,EAAE,mBAAmB,EAAE;AACxD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.admin-navigation {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  padding: 13px 26px;\n  border-bottom: 1px solid #334155;\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.admin-brand {\n  color: #10b981;\n  font-size: 20px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.admin-nav-scroll {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.admin-nav-link {\n  padding: 9px 13px;\n  color: #cbd5e1;\n  text-decoration: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: all .2s;\n}\n\n.admin-nav-link:hover { background: #26384f; color: #f8fafc; }\n.admin-nav-link-active { background: #10b981; color: #0f172a; }\n\n@media (max-width: 760px) {\n  .admin-navigation { padding: 11px 14px; align-items: flex-start; flex-direction: column; gap: 8px; }\n  .admin-nav-scroll { width: 100%; padding-bottom: 3px; }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
